export default __webpack_public_path__ + "static/desk02-ba7ebfe8ad1ce2ad674c00f2cbf1b46b.png";